import { takeEvery, put, call, SagaReturnType } from 'redux-saga/effects';
import facilityService from 'src/services/apiServices/facilityService';
import { TherapistAction, facilityAction } from 'src/redux/actions/constant';

const {
  GET_ASSIGNED_FACILITY_REQUEST,
  GET_ASSIGNED_FACILITY_SUCCESS,
  GET_ASSIGNED_FACILITY_FAILURE,
} = facilityAction;
const { GET_PAYCOME_PROVIDER_REQUEST, GET_CLOCK_IN_OUT_BUTTON_VISIBILITY_REQUEST } =
  TherapistAction;

function* getFacilitiesData(): SagaReturnType<any> {
  try {
    const response = yield call(facilityService.getAssignedFacilities);
    if (response?.status === 200) {
      yield put({ type: GET_ASSIGNED_FACILITY_SUCCESS, payload: response });
      yield put({ type: GET_PAYCOME_PROVIDER_REQUEST });
      yield put({ type: GET_CLOCK_IN_OUT_BUTTON_VISIBILITY_REQUEST });
    } else {
      throw response.data;
    }
  } catch (error) {
    // An empty error body throws a falsy value here. Dispatching it verbatim leaves the reducer's
    // `response` falsy, which every caller reads as "still in flight" — the request then looks
    // permanently pending and the UI waiting on it spins forever (APIT-683). Always settle on
    // something truthy so a failure is distinguishable from an unfinished request.
    yield put({
      type: GET_ASSIGNED_FACILITY_FAILURE,
      payload: error || new Error('Failed to load assigned facilities'),
    });
  }
}

function* getFacilityDropDownSaga() {
  yield takeEvery(GET_ASSIGNED_FACILITY_REQUEST, getFacilitiesData);
}

export default getFacilityDropDownSaga;
